import React, { Component } from 'react';
import PropTypes from 'prop-types';
import plustwo from '../../assets/images/plus2.svg';
import orderBy from 'lodash/orderBy';

class SpecialBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
      specialBoxes: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { specialBoxes } = this.state;
    if (
      (this.props.specialItem &&
        this.props.specialItem.selectedCategories &&
        !specialBoxes) ||
      (!prevProps.selectedSpecials && this.props.selectedSpecials) ||
      (prevProps.selectedSpecials &&
        this.props.selectedSpecials &&
        prevProps.selectedSpecials.length !==
          this.props.selectedSpecials.length)
    ) {
      const specialBoxes = [];
      let z = 0;

      this.props.specialItem.selectedCategories
        .sort((a, b) => a.index - b.index)
        .forEach((sp) => {
          let i = 0;
          for (; i < Number(sp.quantity); i++) {
            let obj = JSON.parse(JSON.stringify(sp));
            obj.boxIndex = i + z;
            specialBoxes.push(obj);
          }
          z += i;
        });

      let selectedSpecials = this.props.selectedSpecials
        ? this.props.selectedSpecials.filter((m) => {
            return m.specialId === this.props.specialItem._id;
          })
        : [];

      if (selectedSpecials.length > 0) {
        const { boxIndex: lastIndex } = this.props;

        let nextItems = specialBoxes.filter((p) => {
          return p.boxIndex === lastIndex + 1;
        });

        if (
          nextItems.length > 0 &&
          window.innerWidth > 991 &&
          !(
            window.navigator.userAgent.match(/iPad/i) &&
            window.innerHeight > 1250
          )
        ) {
          this.setState({ specialBoxes }, () => {
            this.filterView(
              nextItems[0].menuItems ? nextItems[0].menuItems : [],
              nextItems[0].menuSizes ? nextItems[0].menuSizes : [],
              nextItems[0].subModifiers ? nextItems[0].subModifiers : [],
              nextItems[0].categories ? nextItems[0].categories : [],
              lastIndex + 1
            );
            const nextItem = nextItems[0];
            const activeMenuItems = nextItem.menuItems.filter(
              (i) => i.isActive
            );
            if (activeMenuItems.length === 1) {
              setTimeout(() => {
                const menuItemsMap = this.props.menuItems.reduce(
                  (acc, i) => ({ ...acc, [i._id]: i }),
                  {}
                );
                const item = menuItemsMap[activeMenuItems[0]._id];
                this.props.showSpecialItem(item);
              }, 200);
            }
          });
        } else {
          this.setState({ specialBoxes, activeIndex: lastIndex + 1 });
        }
      } else {
        this.setState({ specialBoxes });

        const { menuItems, menuSizes, subModifiers, categories } =
          specialBoxes.find(({ index }) => index === 0);

        if (window.innerWidth > 991) {
          this.filterView(menuItems, menuSizes, subModifiers, categories, 0);
        }
      }
    }
  }

  getImageUrl = (boxIndex) => {
    if (this.props.specialItem && this.props.selectedSpecials) {
      let sps = this.props.selectedSpecials.filter((m) => {
        return (
          m.specialId === this.props.specialItem._id && m.boxIndex === boxIndex
        );
      });
      if (sps && sps.length === 1) {
        return sps[0].urlS3;
      }
      if (sps && sps.length > 1) {
        return this.props.halfHalfSetup.halfHalfPlaceholderImage;
      }
    }
  };

  getName = (boxIndex) => {
    if (this.props.specialItem && this.props.selectedSpecials) {
      let sps = this.props.selectedSpecials.filter((m) => {
        return (
          m.specialId === this.props.specialItem._id && m.boxIndex === boxIndex
        );
      });
      if (sps && sps.length === 1) {
        return sps[0].name;
      }
      if (sps && sps.length > 1) {
        return sps.map(({ name }) => name).join(' / ');
      }
      return false;
    }
    return false;
  };

  getNameEmpty = (specialBox) => {
    if (
      specialBox.categories &&
      (specialBox.menuSizes || specialBox.subModifiers)
    ) {
      let activeCategories = specialBox.categories.filter((f) => f.isActive);
      if (specialBox.displayName) {
        return specialBox.displayName;
      } else {
        let arrayDesciptions = [];
        activeCategories.forEach((c) => {
          let activeSizes = specialBox.menuSize
            ? specialBox.menuSizes.filter((f) => {
                return f.isActive && f.categoryId === c._id;
              })
            : [];
          let activeSubModifiers = specialBox.subModifiers
            ? specialBox.subModifiers.filter((f) => {
                return f.isActive;
              })
            : [];
          arrayDesciptions.push(
            `${[...activeSizes, ...activeSubModifiers]
              .map((m) => m.name)
              .join('/')} ${c.name}`
          );
        });
        return arrayDesciptions.join(' or ');
      }
    }
    return '';
  };

  isSubmitEnabled = () => {
    if (
      this.props.specialItem &&
      this.props.specialItem.selectedCategories &&
      this.props.selectedSpecials
    ) {
      let count = 0;
      let selectedCount = 0;
      this.props.specialItem.selectedCategories.map((m) => {
        count = count + Number(m.quantity);
        return m;
      });
      this.props.selectedSpecials.forEach((s) => {
        selectedCount += Number(s.quantity);
      });
      if (selectedCount >= count) return true;
      return false;
    }
    return false;
  };

  addSpecialToOrder = () => {
    if (this.isSubmitEnabled()) {
      this.props.addSpecialToOrder(this.props.specialItem);
    }
  };

  filterView = (menuItems, menuSizes, subModifiers, categories, index) => {
    let itemExist = this.getImageUrl(index) ? index : -1;
    this.setState(
      {
        activeIndex: index,
      },
      () => {
        this.props.filterView(
          menuItems,
          menuSizes,
          subModifiers,
          categories,
          index,
          itemExist
        );
      }
    );
  };

  render() {
    const { storeConfig, specialItem } = this.props;
    return (
      <div className='specialViewI'>
        {specialItem && (
          <div className='detailsTitle sP' style={{ marginTop: 0 }}>
            {!specialItem.isNameCanBeUsedInFrame
              ? specialItem.description
                ? specialItem.description.length >= 100
                  ? specialItem.description.substring(0, 50).concat('...')
                  : specialItem.description
                : ''
              : specialItem.displayName
              ? specialItem.displayName
              : specialItem.name}
            <span
              style={{ right: 10, top: 67, position: 'absolute' }}
              className='voucher'
            >
              Special
            </span>
          </div>
        )}
        <div className='boxesSP'>
          {this.state.specialBoxes &&
            orderBy(this.state.specialBoxes, ['index'], ['asc']).map(
              (sp, index) => (
                <div
                  key={`${index} index`}
                  className={
                    this.state.activeIndex === index ||
                    this.props.itemExist === index
                      ? 'active bSp'
                      : 'bSp'
                  }
                  onClick={() => {
                    this.filterView(
                      sp.menuItems || [],
                      sp.menuSizes || [],
                      sp.subModifiers || [],
                      sp.categories || [],
                      index
                    );
                  }}
                >
                  <div className='innerSP'>
                    {this.getImageUrl(index) &&
                    this.props.itemExist !== index ? (
                      <img src={this.getImageUrl(index)} alt='' />
                    ) : (
                      this.props.itemExist !== index && (
                        <span>
                          <img src={plustwo} alt='' />
                          Add
                        </span>
                      )
                    )}
                    <div
                      className={
                        this.getName(index) ? 'activeName' : 'nonActive'
                      }
                    >
                      {this.getName(index)
                        ? this.getName(index)
                        : this.getNameEmpty(sp)
                        ? this.getNameEmpty(sp).length >= 10
                          ? this.getNameEmpty(sp).substring(0, 10).concat('...')
                          : this.getNameEmpty(sp)
                        : ''}
                    </div>
                  </div>
                </div>
              )
            )}
        </div>
        <div className='spBtn'>
          <div
            onClick={() => this.addSpecialToOrder()}
            className={
              this.isSubmitEnabled() ? 'confirmBtn' : 'confirmBtn diableConfirm'
            }
          >
            Add to Order
            {this.props.specialItem && this.props.specialItem.type !== '2' && (
              <span className='rb'>{` ${storeConfig.currency}${
                this.props.specialItem?.cost || ''
              }`}</span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SpecialBox.propTypes = {
  specialItem: PropTypes.any,
  halfHalfSetup: PropTypes.any,
  selectedSpecials: PropTypes.any,
  addSpecialToOrder: PropTypes.any,
  rightSideViewVisibilityIndex: PropTypes.any,
  itemExist: PropTypes.any,
};

export default SpecialBox;
